import { observable, decorate, action, computed } from 'mobx'

const defaultPageSizeOptions = [5, 10, 20, 50, 100, 200]

export class StructureWorkStore {
  head
  headInited
  data
  depth
  maxLevelsDepth
  periods
  hits
  page
  pageSize
  pageSizeOptions
  login
  loginLable
  hideInactive
  loading
  changePageSize

  constructor(rootStore) {
    this.head = null
    this.headInited = false
    this.data = null
    this.depth = null
    this.maxLevelsDepth = 5
    this.periods = null
    this.hits = null
    this.page = 1
    this.pageSize = defaultPageSizeOptions[defaultPageSizeOptions.length - 1]
    this.pageSizeOptions = defaultPageSizeOptions
    this.login = null
    this.loginLable = null
    this.hideInactive = false
    this.loading = false
    this.changePageSize = true
    this.rootStore = rootStore
  }
  get methodProps() {
    const tempMethodProps = {
      period_id: this.periods[0].id,
      hide_inactive: this.hideInactive,
      page_by: {
        number: this.page,
        size: this.pageSize,
      },
    }
    if (this.login != null) {
      tempMethodProps.login = this.login
    }
    if (this.depth != null) {
      tempMethodProps.depth = this.depth
    }
    
    //console.log('StructureWorkStore -> getmethodProps', tempMethodProps)
    
    return tempMethodProps
  }
  get headFormated() {
    return this.head.map(item => {
      return {
        title: item.title,
        field: item.data,
      }
    })
  }

  init(result) {
    this.head = result.fields
    this.depth = result.max_levels_depth
    this.maxLevelsDepth = result.max_levels_depth
    this.periods = result.periods
    //console.log('StructureWorkStore -> init -> result', toJS(result))
    //console.log(
    //  'StructureWorkStore -> init -> this.maxLevelsDepth',
    //  toJS(this.maxLevelsDepth)
    //)
    //console.log(
    //  'StructureWorkStore -> init -> this.periods',
    //  toJS(this.periods)
    //)
    //console.log('StructureWorkStore -> init -> this.head', toJS(this.head))
  }
  setHeadInit(bool = false) {
    this.headInited = bool
    //console.log(
    //  'StructureWorkStore -> setHeadInit -> this.headInited',
    //  this.headInited
    //)
  }
  setData(result) {
    this.data = this.rebaseData(result.list)
    this.hits = result.hits
    //console.log('StructureWorkStore -> setData ->  this.hits', toJS(this.hits))
    this.filterPageSizeOptions()
    //console.log('StructureWorkStore -> setData -> this.data', toJS(this.data))
    //console.log('StructureWorkStore -> setData -> result', result)
  }
  rebaseData(data) {
    return data.map(item => {
      Object.keys(item).forEach(key => {
        if (item[key] == null) {
          item[key] = '-'
        }
        if (typeof item[key] === 'object') {
          if (item[key].hasOwnProperty('title')) {
            item[key] = item[key].title
          } else {
            item[key] = '{object}'
          }
        }
        if (Array.isArray(item[key])) {
          item[key] = '[array]'
        }
      })
      return item
    })
  }
  setDepth(value) {
    //console.log('StructureWorkStore -> setDepth -> value', value)
    this.depth = value
    //console.log('StructureWorkStore -> setDepth -> this.depth', this.depth)
  }
  setHideInactive(value) {
    this.hideInactive = value
    //console.log(
    //  'StructureWorkStore -> setHideInactive -> this.hideInactive',
    //  this.hideInactive
    //)
  }
  setPage(value) {
    this.page = value
    //console.log('StructureWorkStore -> setPage -> this.page', this.page)
  }
  setPageSize(value) {
    this.pageSize = value
    //console.log(
    //  'StructureWorkStore -> setPageSize -> this.pageSize',
    //  this.pageSize
    //)
  }
  setLogin(login) {
    this.login = login !== '' ? login : null
    //console.log('StructureWorkStore -> setLogin -> this.login', this.login)
  }
  setLoginLable(login) {
    this.loginLable = login
    //console.log(
    //  'StructureWorkStore -> setLoginLable -> this.loginLable',
    //  this.loginLable
    //)
  }
  setLoading(bool = false) {
    this.loading = bool
    //console.log(
    //  'StructureWorkStore -> setLoading -> this.loading',
    //  this.loading
    //)
  }
  filterPageSizeOptions() {
    //console.log('defaultPageSizeOptions', defaultPageSizeOptions)
    let newPageSizeOptions = defaultPageSizeOptions.filter(
      (size, i) => defaultPageSizeOptions[i - 1] < this.hits
    )

    //console.log('newPageSizeOptions1', newPageSizeOptions)
    newPageSizeOptions =
      newPageSizeOptions != null && newPageSizeOptions.length > 0
        ? newPageSizeOptions
        : [defaultPageSizeOptions[0]]

    //console.log('newPageSizeOptions2', newPageSizeOptions)
    this.changePageSize &&
      this.setPageSize(newPageSizeOptions[newPageSizeOptions.length - 1])
    this.changePageSize = true
    this.pageSizeOptions = newPageSizeOptions
    //console.log(
    //  'StructureWorkStore -> filterPageSizeOptions -> newPageSizeOptions',
    //  newPageSizeOptions
    //)
    // setPageSizeOptions(newPageSizeOptions)
  }
  shouldChangePageSize(bool = true) {
    this.changePageSize = bool
  }
}

decorate(StructureWorkStore, {
  head: observable,
  headInited: observable,
  data: observable,
  depth: observable,
  maxLevelsDepth: observable,
  periods: observable,
  hits: observable,
  page: observable,
  pageSize: observable,
  pageSizeOptions: observable,
  login: observable,
  loginLable: observable,
  hideInactive: observable,
  loading: observable,
  changePageSize: observable,

  methodProps: computed,
  headFormated: computed,

  init: action,
  setData: action,
  rebaseData: action,
  setDepth: action,
  setHideInactive: action,
  setPage: action,
  setPageSize: action,
  setLogin: action,
  setLoginLable: action,
  setLoading: action,
  filterPageSizeOptions: action,
  shouldChangePageSize: action,
})
